import { notify } from "@kyvg/vue3-notification";

export default class NotificationService {
  /**
   * displays an error message
   * @param title message title
   * @param message message content
   */
  static error(title: string, message: string) {
    this.showNotification(title, message, 'error');
  }

  /**
   * displays a warning message
   * @param title message title
   * @param message message content
   */
  static warn(title: string, message: string) {
    this.showNotification(title, message, 'warn');
  }

  /**
   * displays a success message
   * @param title message title
   * @param message message content
   */
  static success(title: string, message: string) {
    this.showNotification(title, message, 'success');
  }

  /**
   * displays an info message
   * @param title message title
   * @param message message content
   */
  static info(title: string, message: string) {
    this.showNotification(title, message, 'info');
  }

  /**
   * A wrapper for vue notification library method with some defaults.
   * @param title message title
   * @param message message content
   * @param type message box class
   */
  private static showNotification(title: string, message: string, type: string) {
    notify({
      type,
      group: 'app-notif',
      title,
      text: message,
    });
  }
}
